@if (breadcrumbItems$ | async; as breadcrumbItems) {
  @for (item of breadcrumbItems; track item; let i = $index) {
    <span
      class="breadcrumb-item"
      [class.clickable]="!item.isMenu && i + 1 !== breadcrumbItems.length"
      [class.breadcrumb-item--root]="i === 0 && item.isNot(latestBreadcrumbItem$ | async)"
      [class.breadcrumb-item--parent]="i > 0 && item.isNot(latestBreadcrumbItem$ | async)"
      (click)="routeToNavigationItem(item, i + 1 === breadcrumbItems.length)"
      >
      @if (item.isNot(latestBreadcrumbItem$ | async)) {
        <span>
          {{ item.name }}
          <i
            eIcon
            class="breadcrumb-chevron"
            icon="chevron-right"
          ></i>
        </span>
      }
      @if (item.is(latestBreadcrumbItem$ | async)) {
        <span class="last-item" (click)="refreshComponent(item)">
          <i
            eIcon
            class="last-item__icon"
            icon="sync-alt"
          ></i>
          {{ item.name }}
        </span>
      }
    </span>
  }
  @if ((appContext.activeNavigationItem$ | async)?.hasWiki) {
    <navigation-item-wiki-button
      class="ml-2"
      [navigationItem]="appContext.activeNavigationItem$ | async"
    ></navigation-item-wiki-button>
  }
  @if (isExternalPage()) {
    <span class="breadcrumb-url-info">{{externalUrl}}</span>
  }
}
